<template>
  <div>
    <b-col class="text-left">
      <router-link :to="{ name: 'CreateForm' }">
        <b-button pill variant="info" class="ml-1 mb-1">
          <b-icon icon="plus" class="mr-3" font-scale="1.5" />ایجاد</b-button
        >
      </router-link>
    </b-col>

    <b-table v-bind="tableAttributes" :fields="fields" :items="items">
      <template #cell(name)="data">
        {{ data.item.name }}
      </template>
      <template #cell(type)="data">
        {{ data.item.type }}
      </template>

      <template #cell(function)="data">
        {{ data.item.function }}

        <b-icon icon="trash" class="ml-4" font-scale="1.5" />
        <router-link :to="{ name: '' }"
          ><b-icon icon="eye-fill" class="ml-4" font-scale="1.5"
        /></router-link>


        <router-link :to="{ name: 'UpdateForm', params: { form: 2 } }">
          <b-icon icon=" pencil" font-scale="1.5" />
        </router-link>

        
      </template>
    </b-table>
  </div>
</template>

<script>
import { tableAttributes } from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";

export default {
  name: "tableItems",
  props: ["restoreState"],
  data() {
    return {
      tableAttributes: { ...tableAttributes, ...{ responsive: "xl" } },
      fields: [
        { key: "name", label: "عنوان" },
        { key: "type", label: "نوع" },
        { key: "function", label: "عملبات" },
      ],
      items: [
        {
          name: "فرم تماس ",
          type: " سفارش",

          function: "",
        },
      ],
      mainProps: { width: 80, height: 80, class: "p-0 rounded" },
    };
  },
};
</script>